'use client';

import React, { Fragment } from 'react';
import { twMerge } from 'tailwind-merge';

import { Divider } from '@/components/ui';

import Link from '../ui/Link';
import { Iconify } from '../iconify';

// Define the type for a social link object
export interface SocialLink {
  name: string;
  icon: string;
  href: string;
  sizes?: {
    width: number;
    height: number;
  };
}

// Define the props for the Social component
export interface SocialProps {
  links: SocialLink[];
  className?: string;
}

/**
 * Social component displays a row of social media icons with links
 *
 * @param links - Array of social link objects
 * @param className - Optional className to override or extend styling
 */
export function Social({ links, className = '' }: SocialProps) {
  return (
    <div className={twMerge('flex items-center w-full  justify-around gap-4', className)}>
      {links.map((link, index) => (
        <Fragment key={link.name}>
          <Link
            href={link.href}
            color="primary" // This applies text-green-600 and hover:text-green-800
            underline="none"
            aria-label={link.name}
            className="flex items-center justify-center"
          >
            <Iconify
              icon={link.icon as any}
              width={link.sizes?.width || 24}
              height={link.sizes?.height || link.sizes?.width || 24}
            />
          </Link>

          {index !== links.length - 1 && (
            <Divider key={`divider-${link.name}`} orientation="vertical" className="min-h-8" />
          )}
        </Fragment>
      ))}
    </div>
  );
}

export default Social;
